import { Component, OnInit, trigger, state, style, transition, animate, ViewChild, ViewContainerRef, Output, EventEmitter} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../services/login/login.service';

@Component({
    selector: 'app-tools-menu',
    templateUrl: './tools-menu.component.html',
    styleUrls: ['./tools-menu.component.css']
})
export class ToolsMenuComponent implements OnInit {
    /* Events Emitter's */
    @Output() private activateTool = new EventEmitter<string>();
    @Output() private closeTools = new EventEmitter<String>();

    private showPanel = {
        draw: false,
        measureLine: false,
        measureSurf: false,
        print: false
    };

    private drawToolClasses = {
        toolMenuItemHeader: true,
        unactive: !this.showPanel.draw,
        active: this.showPanel.draw,
    };

    private measureDistanceToolClasses = {
        toolMenuItemHeader: true,
        unactive: !this.showPanel.measureLine,
        active: this.showPanel.measureLine
    };

    private measureSurfaceToolClasses = {
        toolMenuItemHeader: true,
        unactive: !this.showPanel.measureSurf,
        active: this.showPanel.measureSurf
    };

    private printToolClasses = {
        toolMenuItemHeader: true,
        unactive: !this.showPanel.print,
        active: this.showPanel.print
    };

    constructor(private translateService: TranslateService,
        private loginService: LoginService,) {
        console.debug(">>> ToolsMenuComponent --> constructor");

    }

    ngOnInit() {

        console.debug(">>> ToolsMenuComponent --> ngOnInit");
        this.showPanel = {
            draw: false,
            measureLine: false,
            measureSurf: false,
            print: false
        };

        this.drawToolClasses = {
            toolMenuItemHeader: true,
            unactive: !this.showPanel.draw,
            active: this.showPanel.draw,
        };

        this.measureDistanceToolClasses = {
            toolMenuItemHeader: true,
            unactive: !this.showPanel.measureLine,
            active: this.showPanel.measureLine
        };

        this.measureSurfaceToolClasses = {
            toolMenuItemHeader: true,
            unactive: !this.showPanel.measureSurf,
            active: this.showPanel.measureSurf
        };

        this.printToolClasses = {
            toolMenuItemHeader: true,
            unactive: !this.showPanel.print,
            active: this.showPanel.print
        };
    }



    /*
    * Mostra la eina de measure line.
    * Requisits per a que funcioni: netejar les capes d'eines que estan afegides al mapa.
    */
    private showMeasureLine() {
        console.debug(" >>> ToolsMenuComponent: showMeasureLine");
        this.activateTool.emit("olMeasureDistance");
        this.showPanel.measureSurf = false;
        this.showPanel.measureLine = true;
        this.showPanel.draw = false;
        this.showPanel.print = false;
    }

    private showMeasureSurface() {
        console.debug(">>> ToolsMenuComponent --> showMeasureSurface");
        this.activateTool.emit("olMeasureSurface");
        this.showPanel.measureSurf = true;
        this.showPanel.measureLine = false;
        this.showPanel.draw = false;
        this.showPanel.print = false;
    }

    private showDraw() {
        console.debug(">>> ToolsMenuComponent --> showDraw");
        this.activateTool.emit("olDrawTool");
        this.showPanel.measureSurf = false;
        this.showPanel.measureLine = false;
        this.showPanel.draw = true;
        this.showPanel.print = false;
    }

    private togglePrint() {
        this.activateTool.emit("olPrintTool");
        this.showPanel.measureSurf = false;
        this.showPanel.measureLine = false;
        this.showPanel.draw = false;
        this.showPanel.print = true;
    }

    private closeToolsHandler() {
        this.closeTools.emit("tools");
    }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools-menu/tools-menu.component.ts